import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import BioAdmin from 'types/ba/bioAdmin';

export const BioConfigServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: '/bin/lt/biosFeaturesConfig',
	headers: {
		'Content-Type': 'application/json; charset=UTF-8',
	},
});

export default class BioConfigService extends ApiService implements BioAdmin.IBioConfigService {
	constructor() {
        super('bio-admin-config-service', BioConfigServiceAxiosInstance);
    }

	public getRoleConfig(): AxiosPromise<BioAdmin.IBiosConfigResponse> {
		return this.axiosInstance.get('');
	}
}